import styles from './ButtonCircleWithChevron.module.scss'
import Chevron from 'public/images/chevron.svg'
import { MouseEventHandler } from 'react'

interface ButtonCircleWithChevronProps {
  direction: 'left' | 'right' | 'up' | 'down'
  onClick: MouseEventHandler
}

export default function ButtonCircleWithChevron(props: ButtonCircleWithChevronProps) {
  const { direction, onClick } = props
  return(
    <div className={ styles.ButtonCircleWithChevron }>
      <button 
        className={ styles.buttonCircle }
        onClick={ onClick }
      >
        <Chevron className={ `${styles.chevron} ${styles[direction]}` } />
      </button>
    </div>
  )
}
